import React from 'react'
import styles from '../../styles.module.css'

export const Loader = (props) => {
  if (props.loading)
    return (
      <div className={styles.loader_container}>
        <div className={styles.md_preloader}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            version='1.1'
            height='50'
            width='50'
            viewBox='0 0 50 50'
          >
            <circle cx='25' cy='25' r='21' strokeWidth='6' />
          </svg>
        </div>
      </div>
    )
  else return null
}
